export enum CheckoutEnum {
  account = 'account',
  guest = 'guest',
  paypal = 'paypal'
}
